import { render, staticRenderFns } from "./contact-us-phone.vue?vue&type=template&id=4d64c66e&scoped=true&"
import script from "./contact-us-phone.vue?vue&type=script&lang=js&"
export * from "./contact-us-phone.vue?vue&type=script&lang=js&"
import style0 from "./contact-us-phone.vue?vue&type=style&index=0&id=4d64c66e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d64c66e",
  null
  
)

export default component.exports